import { useTranslation } from 'react-i18next';
import {
  MyConsolidatedResponse,
} from '@sentara-health/sentara-api-hooks-core';
import {
  CircleProgress,
  PrimaryCircleProgressBar,
  Paragraph
} from '@sentara-health/optimahealth_web';


interface OverviewProps {
  readonly myConsResState: MyConsolidatedResponse | [];
}

function Overview(props: OverviewProps) {
  const { myConsResState } = props;
  const { t } = useTranslation();
  const deductible = t('yourPlan.deductible');

  return (
    <div className="my_plan_overview">
      {myConsResState && myConsResState?.length > 0 ? (
        <div>
          {myConsResState &&
            myConsResState?.length > 0 &&
            myConsResState?.map((item) => (
              <div
                data-testid="my_plan_container"
                className="my_plan_container"
                key={item.benefitDescription}
              >
                <div>

                  <div className="heading-with-bg-center">
                    <Paragraph
                      text={
                          (item.benefitDescription).toUpperCase() === deductible
                          ? t('common.deductible')
                          : t('yourPlan.inNetworkMoop')
                      }
                      variant="bold"
                      className="text-center heading-with-bg-center col-auto mb-3"
                      data-testid={
                        (item.benefitDescription).toUpperCase() === deductible
                          ? 'deductible_header'
                          : 'moop_header'
                      }

                    />
                  </div>
                  <Paragraph text={t(item?.networkType)} variant="regular" data-testid={
                    item.benefitDescription === deductible
                      ? 'deductible_network'
                      : 'moop_network'
                  } className="text-center border-bottom pb-2" />


                  <div className="row justify-content-center">
                    <div
                      className="col-lg-5 col-md-5 col-sm-12 col-12 mb-4"
                      data-testid={
                        item.benefitDescription === deductible
                          ? 'deductible_progressbar_member'
                          : 'moop_progressbar_membr'
                      }
                    >
                      <PrimaryCircleProgressBar
                        className="circle-progress-member"
                        header={t(item.member?.name)}
                        percentage={item.member?.amount}
                        total={item.member?.limit}
                        dataTestId={
                          item.benefitDescription === deductible
                            ? 'deductible_member'
                            : 'moop_member'
                        }
                      />
                    </div>
                    <div
                      className="col-lg-5 col-md-5 col-sm-12 col-12 mb-4 deductible_progressbar_member"
                      data-testid={
                        item.benefitDescription === deductible
                          ? 'deductible_progressbar_family'
                          : 'moop_progressbar_family'
                      }
                    >
                      <CircleProgress
                        className="circle-progress-family"
                        header={t(item.family?.name)}
                        percentage={item.family?.amount}
                        total={item.family?.limit}
                        dataTestId={
                          item.benefitDescription === deductible
                            ? 'deductible_family'
                            : 'moop_family'
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      ) : (
        <Paragraph text={t('yourPlan.moopMsg')} variant="regular" />
      )}
    </div>
  );
}

export default Overview;